
























import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import { Book } from '@/modules/Book/interfaces/book'
import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { mixins } from 'vue-class-component'
import BookDialog from '@/modules/Book/scripts/book-dialog'
import AppTextField from '@/components/AppTextField.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppTextField
  }
})
export default class BookDetailDetail extends mixins(BookDialog) {
  @Prop({ type: Object as () => Book }) readonly book!: Book

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  editBlock = ''

  bookInput: {
    [key: string]: string;
  } = {
    name: ''
  }

  mounted () {
    this.onBookUpdated(this.book)
  }

  @Watch('book', { deep: true })
  onBookUpdated (val: Book) {
    this.bookInput = {
      name: val.name || ''
    }
  }

  @Watch('editBlock')
  editBlockChanged (val: string) {
    this.onBookUpdated(this.book)
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  clearBookInput () {
    this.bookInput = {
      name: ''
    }
  }
}
